export const findItemIndex = (arr, id) => arr.findIndex(item => parseInt(item.id, 10) === parseInt(id, 10));

export const sortEvents = (a, b) => {
  const ta = parseInt(a.gameTime, 10);
  const tb = parseInt(b.gameTime, 10);

  if (ta === tb) {
    const ia = parseInt(a.id, 10);
    const ib = parseInt(b.id, 10);

    // eslint-disable-next-line
    return ia < ib ? 1 : (ia > ib ? -1 : 0);
  }

  if (ta < tb) {
    return 1;
  }

  if (ta > tb) {
    return -1;
  }

  return 0;
};


export default (data) => {
  const all = [];
  // const goals = [];
  // const penalties = [];

  data
    .sort(sortEvents)
    .forEach((item) => {
      if (!item.method || item.method === 'insert') {
        // if (item.updateType === 'goal') goals.push(item);
        // if (item.updateType === 'penalty') {
        //   penalties.push(item);
        // }

        all.push(item);
      } else if (item.method) {
        if (item.method === 'update') {
          const newItem = { ...item, method: null };

          // if (item.updateType === 'goal') goals[findItemIndex(goals, item.id)] = newItem;
          // if (item.updateType === 'penalty') {
          //   penalties[findItemIndex(penalties, item.id)] = newItem;
          // }

          all[findItemIndex(all, item.id)] = newItem;
        } else if (item.method === 'delete') {
          // const goalsIndex = findItemIndex(goals, item.id);
          // if (goalsIndex > -1) goals.splice(goalsIndex, 1);

          // const penaltiesIndex = findItemIndex(penalties, item.id);
          // if (penaltiesIndex > -1) penalties.splice(penaltiesIndex, 1);

          const allIndex = findItemIndex(all, item.id);
          if (allIndex > -1) all.splice(allIndex, 1);
        }
      }
    });

  return all;

  // return {
  //   TORE: goals,
  //   TICKER: all,
  //   STRAFEN: penalties,
  // };
};



// WEBPACK FOOTER //
// ./src/browser/liveticker.data.js